<template>
  <div class="pay_back">
      <div class="content">
            <div class="title hight">请确认微信支付是否完成</div>
            <div class="success hight" @click="toHome()">已完成支付</div>
            <div class="failure hight"  @click="payAgain()">支付遇到问题，重新支付</div>
      </div>
  </div>
</template>

<script>
  import weixinService from "../../services/weixin-service.js";
  import httpService from "../../services/http-service.js";

  export default {
    data() {
      return {
        payData: {},
        PayNo: ''
      }
    },
    methods: {
        toHome() {
          const start = Date.parse(new Date("2021/09/15 00:00:00"));
          const end = Date.parse(new Date("2021/09/22 00:00:00"));
          const now = Date.parse(new Date());
          if( now < end && now > start){
              window.location.href = "https://act.gdtvdv.com/dist/index.html#/oneyuan?actid=11&no=091414435302"
          } else {
            this.$router.push({ path: '/home' })
          }
          
        },
        payAgain() {
            this.$router.push({ path: '/pay' })
        }
    },
    created() {
     
    }
  }
</script>

<style scoped>
  .pay_back {
    font-size: .16rem;
    padding: .1rem;
    background: grey;
    position: relative;
    height: 100%;
  }
  .content{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -70%);
      width: 78%;
      height: 3rem;
      background: #fff;
      border-radius: 0.1rem;
  }
  .hight{
      height: 1rem;
      text-align: center;
      line-height: 1rem;
      font-size: 0.26rem;
      border-bottom: 1px solid #ccc;
      box-sizing: border-box;
  }
  .hight:nth-child(3){
      border-bottom: 0 none;
  }
  .success{
      color: red;
      font-weight: bold;
  }
</style>


// WEBPACK FOOTER //
// src/component/pay/payBack.vue